module.exports = __webpack_public_path__ + "static/media/curve-3.5e32a673.svg";